import { Radio } from 'taboola-ultimate-ui';
import { FormattedMessage } from '../../../../../../../taboola-common-frontend-modules/i18n';
import { useTrackingDataForBidStrategy } from '../../../../../../../tracking/hooks/useTrackingDataForBidStrategy';
import { BID_STRATEGIES } from '../../../../config';
import { TargetCpaStrategy } from '../../TargetCpaStrategy/TargetCpaStrategy';
import { TargetCpaTitle } from '../../TargetCpaStrategy/TargetCpaTitle/TargetCpaTitle';
import { useTargetCpaAvailability } from '../../hooks/useTargetCpaAvailability';
import styles from './targetCpaRadio.module.scss';

export const TargetCpaRadio = ({ bidStrategy }) => {
    const targetCpaAvailabilityProps = useTargetCpaAvailability();
    const { disableCpa, shouldDisableCpaOnDuplicate } = targetCpaAvailabilityProps;
    const { isPixelOrS2sInstalled, hasAtLeastOneActiveConversion, isTcpaPixelValidationEnabled } =
        useTrackingDataForBidStrategy();
    const missingPixelOrActiveConversion =
        isTcpaPixelValidationEnabled && (!isPixelOrS2sInstalled || !hasAtLeastOneActiveConversion);

    return (
        <Radio
            labelClassName={styles['radio-label']}
            childrenContainerClassName={styles['radio-child']}
            title={
                <TargetCpaTitle
                    {...targetCpaAvailabilityProps}
                    isPixelOrS2sInstalled={isPixelOrS2sInstalled}
                    hasAtLeastOneActiveConversion={hasAtLeastOneActiveConversion}
                    isTcpaPixelValidationEnabled={isTcpaPixelValidationEnabled}
                    titleMsgId="campaign.editor.target.cpa.bid.title"
                />
            }
            description={
                <FormattedMessage
                    id="campaign.editor.applyCap.target.cpa.bid.description"
                    defaultMessage="Your bid will adjust to reach your target cost per action."
                />
            }
            value={BID_STRATEGIES.TARGET_CPA}
            disabled={missingPixelOrActiveConversion || disableCpa || shouldDisableCpaOnDuplicate}
        >
            {bidStrategy === BID_STRATEGIES.TARGET_CPA && <TargetCpaStrategy showLabel={false} />}
        </Radio>
    );
};
